import React, { useEffect, useState } from "react";
import "./ProfilePopup.css";
import { useTranslation } from "react-i18next";
import { fetchNotifications, readAllNotifications } from "../../store/appSlice";
import { ReactComponent as ProfileIcon } from "../../assets/menu-profile-icon.svg";
import { ReactComponent as TariffIcon } from "../../assets/menu-tariff-icon.svg";
import { ReactComponent as LogoutIcon } from "../../assets/menu-logout-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { notificationsSelector, userSelector } from "../../store/selectors";
import { ReactComponent as ProfileNotificationsIcon } from "../../assets/profile-notifications.svg";
import { ReactComponent as ProfileSecurityIcon } from "../../assets/profile-security.svg";
import { ReactComponent as ProfileActiveSessionsIcon } from "../../assets/profile-active-sessions.svg";
import { ReactComponent as ProfileSupportIcon } from "../../assets/SupportIcon.svg";
import bellIcon from "../../assets/bell.svg";
import { ReactComponent as ProfileArrow } from "../../assets/ProfileArrow.svg";
import { ReactComponent as ProfileTeamIcon } from "../../assets/users.svg";
import { ReactComponent as BellIcon } from "../../assets/bell.svg";
import Avatar from "../Avatar/Avatar";
import { useNavigate } from "react-router";
import { useAuth } from "../../context/AuthContext";

const ProfilePopup = ({}) => {
  const [shopPopup, setShowPopup] = useState(false);
  const [isHovered, setIsHovered] = useState("");
  const { logout } = useAuth();
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const userName = user.email;
  const navigate = useNavigate();

  useEffect(() => {
    const handleClick = (e) => {
      if (
        !e.target.closest(".user-btn") &&
        !e.target.closest(".user-menu-popup")
      ) {
        setShowPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <>
      <button
        className="user-btn"
        onClick={() => setShowPopup((v) => !v)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Avatar user={user} name={userName} size={24} />
        <ProfileArrow
          style={{
            color: isHovered ? "#F1F7FF" : "#717B8E",
            width: 10,
            height: 10,
            marginLeft: 8,
          }}
        ></ProfileArrow>
      </button>
      {(shopPopup && (
        <div className="user-menu-popup">
          <button
            className="user-menu-item"
            onClick={() => {
              setShowPopup(false);
              navigate("/profile");
            }}
          >
            <ProfileIcon style={{ marginRight: 5 }} />
            Профиль
          </button>
          <button
            className="user-menu-item"
            style={{ paddingLeft: 11 }}
            onClick={() => {
              setShowPopup(false);
              navigate("/team");
            }}
          >
            <ProfileTeamIcon style={{ height: 14 }} />
            Доступы и команда
          </button>
          {!!user.role && user.role === "ADMIN" && (
            <button
              className="user-menu-item"
              onClick={() => {
                setShowPopup(false);
                navigate("/profile/admin/dashboard");
              }}
            >
              <ProfileIcon style={{ marginRight: 5 }} />
              Админка
            </button>
          )}
          <button
            onClick={() => {
              setShowPopup(false);
              navigate("/pricing");
            }}
            style={{ paddingLeft: 14 }}
            className="user-menu-item"
          >
            <TariffIcon style={{ marginRight: 5, height: 18 }} />
            Тарифный план
          </button>
          <button
            onClick={() => {
              setShowPopup(false);
              navigate("/payment-methods");
            }}
            style={{ paddingLeft: 14 }}
            className="user-menu-item"
          >
            <TariffIcon style={{ marginRight: 5, height: 18 }} />
            Способы оплаты
          </button>
          <button
            onClick={() => {
              setShowPopup(false);
              navigate("/notifications");
            }}
            style={{ paddingLeft: 13 }}
            className="user-menu-item"
          >
            <ProfileNotificationsIcon style={{ marginRight: 3, height: 18 }} />
            Уведомления
          </button>
          <button
            onClick={() => {
              setShowPopup(false);
              navigate("/security");
            }}
            style={{ paddingLeft: 13 }}
            className="user-menu-item"
          >
            <ProfileSecurityIcon style={{ marginRight: 3, height: 18 }} />
            Безопасность
          </button>
          <button
            onClick={() => {
              setShowPopup(false);
              navigate("/active-sessions");
            }}
            style={{ paddingLeft: 13 }}
            className="user-menu-item"
          >
            <ProfileActiveSessionsIcon style={{ marginRight: 3, height: 18 }} />
            Активные сессии
          </button>
          <button
            onClick={() => {
              setShowPopup(false);
              navigate("/support");
            }}
            style={{ paddingLeft: 13 }}
            className="user-menu-item"
          >
            <ProfileSupportIcon style={{ marginRight: 3, height: 16 }} />
            Поддержка
          </button>
          <button
            style={{ paddingLeft: 15 }}
            className="user-menu-item"
            onClick={logout}
          >
            <LogoutIcon style={{ marginRight: 5 }} />
            Выйти
          </button>
        </div>
      )) ||
        null}
    </>
  );
};

export default ProfilePopup;
